import React from 'react';
import { FadeInSection } from '../ui/FadeInSection';
import { CTAButton } from '../ui/CTAButton';
export function HeroSection() {
  return <section className="py-16 md:py-24 bg-[#FFFBF0] px-4" data-id="element-268">
      <div className="max-w-4xl mx-auto text-center" data-id="element-269">
        <FadeInSection data-id="element-270">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6" data-id="element-271">
            ¿Cansado de Luchar Contra los Antojos y Sentirte Agotado Todo el
            Día?
          </h1>
        </FadeInSection>

        <FadeInSection delay={0.2} data-id="element-272">
          <h2 className="text-xl md:text-2xl text-gray-700 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-273">
            Descubre el método simple para estabilizar tu azúcar en sangre,
            apagar el hambre incontrolable y recuperar tu energía...{' '}
            <span className="font-bold text-green-700" data-id="element-274">
              sin renunciar a tus comidas favoritas.
            </span>
          </h2>
        </FadeInSection>

        <FadeInSection delay={0.4} data-id="element-275">
          <div className="relative max-w-2xl mx-auto mb-12 rounded-2xl overflow-hidden shadow-2xl" data-id="element-276">
            <img src="https://cdn.magicpatterns.com/uploads/iqbiJSaQZ9vhcPzXLQfyne/heylloyd-image-1772648876978.png" alt="El Código del Azúcar en Sangre eBook" className="w-full h-auto object-cover" data-id="element-277" />
          </div>
        </FadeInSection>

        <FadeInSection delay={0.6} data-id="element-278">
          <CTAButton text="Quiero Controlar Mis Antojos Hoy" data-id="element-279" />
          <p className="mt-4 text-sm text-gray-500" data-id="element-280">
            Acceso inmediato • Pago 100% seguro
          </p>
        </FadeInSection>
      </div>
    </section>;
}